import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';


const RegistrationChart = ({ data }: any) => (
  <LineChart width={380} height={200} data={data} margin={{ top: 20, right: 20, bottom: 5, left: 0 }}>
    <Line type="monotone" dataKey="register" stroke="#F2994A" />
    <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
    <XAxis dataKey="week" />
    <YAxis />
    <Tooltip />
  </LineChart>
);

export default RegistrationChart;